<template>
    <div class="success-page">
        <!-- 成功图标容器 -->
        <div class="success-icon-container">
            <div class="success-icon">
                <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                    <circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none" />
                    <path class="checkmark-check" fill="none" d="m16 27 7 7 16-16" />
                </svg>
            </div>
        </div>

        <!-- 成功文案 -->
        <div class="success-content">
            <h2 class="success-title">{{ title || "操作成功" }}</h2>
            <p class="success-description" v-if="description">{{ description }}</p>
        </div>

        <!-- 操作按钮区域 -->
        <!-- <div class="success-actions">
            <button v-if="showReturnBtn" class="btn btn-primary" @click="handleReturn">
                {{ returnBtnText || "返回" }}
            </button>

            <button v-if="showContinueBtn" class="btn btn-secondary" @click="handleContinue">
                {{ continueBtnText || "继续操作" }}
            </button>

            <button v-if="showHomeBtn" class="btn btn-outline" @click="handleGoHome">
                {{ homeBtnText || "返回首页" }}
            </button>
        </div> -->

        <!-- 自定义插槽 -->
        <div class="success-extra" v-if="$slots.extra">
            <slot name="extra"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "SuccessPage",
    props: {
        // 标题
        title: {
            type: String,
            default: "操作成功"
        },
        // 描述文字
        description: {
            type: String,
            default: ""
        },
        // 是否显示返回按钮
        showReturnBtn: {
            type: Boolean,
            default: true
        },
        // 返回按钮文字
        returnBtnText: {
            type: String,
            default: "返回"
        },
        // 是否显示继续操作按钮
        showContinueBtn: {
            type: Boolean,
            default: false
        },
        // 继续操作按钮文字
        continueBtnText: {
            type: String,
            default: "继续操作"
        },
        // 是否显示返回首页按钮
        showHomeBtn: {
            type: Boolean,
            default: false
        },
        // 返回首页按钮文字
        homeBtnText: {
            type: String,
            default: "返回首页"
        },
        // 自动返回时间（秒）
        autoReturn: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            countDown: 0,
            timer: null
        }
    },
    mounted() {
        // 启动动画
        this.startAnimation()

        // 如果设置了自动返回
        if (this.autoReturn > 0) {
            this.countDown = this.autoReturn
            this.startCountDown()
        }
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    },
    methods: {
        // 启动成功动画
        startAnimation() {
            this.$nextTick(() => {
                const circle = this.$el.querySelector(".checkmark-circle")
                const check = this.$el.querySelector(".checkmark-check")

                if (circle && check) {
                    // 添加动画类
                    setTimeout(() => {
                        circle.classList.add("animate")
                    }, 100)

                    setTimeout(() => {
                        check.classList.add("animate")
                    }, 300)
                }
            })
        },

        // 开始倒计时
        startCountDown() {
            this.timer = setInterval(() => {
                this.countDown--
                if (this.countDown <= 0) {
                    clearInterval(this.timer)
                    this.handleReturn()
                }
            }, 1000)
        },

        // 返回操作
        handleReturn() {
            this.$emit("return")
            if (this.$router) {
                this.$router.go(-1)
            }
        },

        // 继续操作
        handleContinue() {
            this.$emit("continue")
        },

        // 返回首页
        handleGoHome() {
            this.$emit("go-home")
            if (this.$router) {
                this.$router.push("/")
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.success-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #333;
}

.success-icon-container {
    margin-bottom: 30px;
}

.success-icon {
    width: 80px;
    height: 80px;
    background: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    animation: bounce 0.6s ease-out;
}

.checkmark {
    width: 50px;
    height: 50px;

    .checkmark-circle {
        stroke-dasharray: 166;
        stroke-dashoffset: 166;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke: #4caf50;

        &.animate {
            animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
        }
    }

    .checkmark-check {
        stroke-dasharray: 48;
        stroke-dashoffset: 48;
        stroke-width: 3;
        stroke-miterlimit: 10;
        stroke: #4caf50;

        &.animate {
            animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
        }
    }
}

.success-content {
    text-align: center;
    margin-bottom: 40px;

    .success-title {
        font-size: 24px;
        font-weight: 600;
        color: #fff;
        margin: 0 0 12px 0;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .success-description {
        font-size: 16px;
        color: rgba(255, 255, 255, 0.9);
        line-height: 1.5;
        margin: 0;
        max-width: 300px;
    }
}

.success-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    max-width: 280px;
}

.btn {
    padding: 14px 28px;
    border: none;
    border-radius: 25px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
    text-align: center;
    min-height: 48px;

    &:active {
        transform: translateY(1px);
    }

    &.btn-primary {
        background: #4caf50;
        color: #fff;
        box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);

        &:hover {
            background: #45a049;
            box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
        }
    }

    &.btn-secondary {
        background: #2196f3;
        color: #fff;
        box-shadow: 0 4px 15px rgba(33, 150, 243, 0.3);

        &:hover {
            background: #1976d2;
            box-shadow: 0 6px 20px rgba(33, 150, 243, 0.4);
        }
    }

    &.btn-outline {
        background: transparent;
        color: #fff;
        border: 2px solid rgba(255, 255, 255, 0.8);

        &:hover {
            background: rgba(255, 255, 255, 0.1);
            border-color: #fff;
        }
    }
}

.success-extra {
    margin-top: 20px;
    width: 100%;
    max-width: 300px;
}

// 动画定义
@keyframes bounce {
    0%,
    20%,
    53%,
    80%,
    100% {
        transform: translate3d(0, 0, 0);
    }
    40%,
    43% {
        transform: translate3d(0, -8px, 0);
    }
    70% {
        transform: translate3d(0, -4px, 0);
    }
    90% {
        transform: translate3d(0, -2px, 0);
    }
}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}

// 响应式设计
@media (max-width: 480px) {
    .success-page {
        padding: 16px;
    }

    .success-icon {
        width: 70px;
        height: 70px;
    }

    .checkmark {
        width: 40px;
        height: 40px;
    }

    .success-title {
        font-size: 20px;
    }

    .success-description {
        font-size: 14px;
    }

    .btn {
        padding: 12px 24px;
        font-size: 14px;
    }
}
</style>
